var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-wrapper',{attrs:{"title":"News"}},[_c('file-list',{attrs:{"file-types":_vm.fileTypes,"allows-archives":true,"is-logged-in":_vm.$parent.loggedIn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }